import { Show } from "@refinedev/antd";
import { Typography, Card, Row, Col, Space, Flex, Divider } from "antd";
import { useShow, useTranslate } from "@refinedev/core";
import { DateField, TextField } from "@refinedev/antd";

const { Title, Text } = Typography;

export const ServiceProviderShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading } = queryResult;
    const _t = useTranslate();

    const record = data?.data;

    return (
        <div className="max-w-7xl mx-auto">
        <Show isLoading={isLoading}>
            <Space direction="vertical" size="large" className="w-full">
                <Space direction="vertical" size="small" className="w-full">
                    <Title level={2}>{record?.name}</Title>
                </Space>

                <Card title={_t("service-providers.fields.apiAndCredentials")} size="small">
                    <Row gutter={[24, 24]}>
                        <Col xs={24}>
                            <Space direction="vertical" size="small">
                                <Text type="secondary">{_t("service-providers.fields.apiEndpoint")}</Text>
                                <Text strong className="font-mono break-all">{record?.apiEndpoint}</Text>
                            </Space>
                        </Col>
                        <Col xs={24} sm={12} md={12}>
                            <Space direction="vertical" size="small">
                                <Text type="secondary">{_t("service-providers.fields.clientId")}</Text>
                                <Text strong className="font-mono">{record?.clientId}</Text>
                            </Space>
                        </Col>
                        <Col xs={24} sm={12} md={12}>
                            <Space direction="vertical" size="small">
                                <Text type="secondary">{_t("service-providers.fields.clientSecret")}</Text>
                                <Text strong className="font-mono">{record?.clientSecret}</Text>
                            </Space>
                        </Col>
                    </Row>
                </Card>
                
                <Divider className="mt-12 mb-0" />
                <Row gutter={[{ xs: 8, sm: 16, md: 24 }, 16]}>
                    <Col xs={12} sm={8} md={6} >
                        <Flex gap="middle">
                            <Text strong type="secondary">{_t("fields.createdAt")} : </Text>
                            <DateField value={record?.createdAt} type="secondary" format="DD/MM/YYYY" />
                        </Flex>
                    </Col>
                    <Col xs={12} sm={8} md={6}>
                        <Flex gap="middle">
                            <Text strong type="secondary">{_t("fields.updatedAt")} : </Text>
                            <DateField value={record?.updatedAt} type="secondary" format="DD/MM/YYYY" />
                        </Flex>
                    </Col>
                </Row>
                </Space>
            </Show>
        </div>
    );
};

